<template>
    <div :class="classMainBlock">
        <label v-if="title">
            {{ title }}
        </label>

        <vue-multiselect
            v-model="itemModel"
            :close-on-select="false"
            :clear-on-select="false"
            :disabled="disabled"
            :maxHeight="200"
            :multiple="true"
            :max="max"
            :options="itemsData"
            :searchable="searchable"
            :show-labels="false"
            label="name"
            :placeholder="placeholder"
            track-by="id"
            @input="onChange"
        />
    </div>
</template>

<script>
export default {
    props: ['title', 'id', 'searchable', 'text', 'items', 'selected', 'route', 'classMainBlock', 'classSelect', 'placeholder', 'disabled', 'max'],
    data: function () {
        return {
            itemModel: null,
            itemValue: null,
            itemsData: [],
        };
    },
    watch: {
        items: {
            handler() {
                this.getItems();
            },
            immediate: true,
        },
    },
    methods: {
        onChange() {
            let ids = [];
            if (this.itemModel) {
                this.itemModel.forEach((val) => {
                    ids.push(val.id);
                });
            }
            this.setValue(ids);
            this.emitChange();
        },
        getItems() {
            if (this.items) {
                this.itemsData = this.items || [];
                this.setModelAndValue(this.selected);
                this.selected && this.emitChange();
                this.emitSetItems();
            } else if (this.route) {
                axios.get(this.route).then((response) => {
                    this.itemsData = response.data;
                    this.setModelAndValue(this.selected);
                    this.selected && this.emitChange();
                    this.emitSetItems();
                });
            }
        },
        getValue() {
            return this.itemValue;
        },
        setModel(ids) {
            this.itemModel = ids ? this.itemsData.filter((value) => ids.indexOf(value.id) !== -1) : null;
        },
        setValue(id) {
            this.itemValue = id;
        },
        setModelAndValue(ids) {
            this.setModel(ids);
            this.setValue(ids);
        },
        emitChange() {
            this.$emit('change', this.itemValue);
        },
        emitSetItems() {
            this.$emit('setItems', this.itemsData, this.id);
        },
        clear() {
            this.itemModel = this.itemValue = null;
        },
    },
};
</script>
